import React from 'react';
import { bool, shape, string } from 'prop-types';

const RoadWorks = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M17 14.1289L18.6592 18H21V20H3V18H5.34082L7 14.1289V14H17V14.1289ZM7.5166 18H16.4834L15.626 16H8.37402L7.5166 18Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M16.0879 12H7.91211L12 2.46094L16.0879 12ZM10.9443 10H13.0557L12 7.53711L10.9443 10Z" fill="currentColor" />
  </svg>
);

RoadWorks.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default RoadWorks;
